import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-admin-downloaded-documents',
  templateUrl: './admin-downloaded-documents.component.html',
  styleUrls: ['./admin-downloaded-documents.component.css']
})
export class AdminDownloadedDocumentsComponent {

  constructor(private _router: Router) { }

  ngOnInit(): void {
  }

  goToReport() {
    this._router.navigate(['/' + Routes.adminDownloadedDocumentsReport]);
  }
}
